import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/landing.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import Footer from "../components/Footer/Footer";
import LandingPageDesktop from "../components/LandingPage/LandingPageDesktop";
import LandingPageResponziv from "../components/LandingPage/LandingPageResponziv";



import{
	MDBContainer,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class LandingPage extends Component {

	constructor(props) {
    super(props);
    this.state = {
									};
  };

	componentDidMount() {
	}

	componentWillUnmount() {
	}


  render() {
    return (
			<>
			<div className="d-none d-lg-block">
				<LandingPageDesktop/>
			</div>
			<div className="d-lg-none d-block">
				<LandingPageResponziv/>
			</div>
			</>
    );
  }
}
export default  LandingPage;
